const CATEGORIES = {
  blueprints: require('./AntIcon113.png').default,
  concepts: require('./AntIcon6.png').default,
  // faqs: require('./faqs_icon.svg').default,
  guides: require('./AntIcon168.png').default,
  integrations: require('./AntIcon232.png').default,
  // newFeatures: require('./new_features_icon.svg').default,
  references: require('./AntIcon115.png').default,
  releases: require('./AntIcon163.png').default,
  // releases: require('./medal_icon.png').default,
  tools: require('./AntIcon63.png').default,
};

export default CATEGORIES;
